<div
  class="wrapper-status visual-builder-block mobile-selection"
  [class.selected]="selectedId?.id === 'sidebar'"
  [class.show-more-opened]="moreValues && !showMoreSideBarItems"
  [ngStyle]="{
    backgroundColor: sidebar?.backgroundColor || '#fff',
    borderColor: sidebar?.borderColor,
    boxShadow: sidebar?.shadow || 'none',
    'borderRadius.px': sidebar?.borderRadius,
    'borderWidth.px': sidebar?.borderWidth
  }"
  (click)="selectBlock.emit('sidebar')"
>
  <div class="sidebar-wrapper visual-builder-block">
    <div class="sidebar-mobile-header">
      <h5 class="sidebar-mobile-header__title">Sidebar Menu</h5>
      <span class="cursor-pointer" (click)="toggleSidebar.emit()">
        <svg
          fill="none"
          height="24"
          viewBox="0 0 24 24"
          width="24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            clip-rule="evenodd"
            d="m17.6629 4.9229c.3905-.39053 1.0237-.39053 1.4142 0 .3905.39052.3905 1.02369 0 1.41421l-5.6629 5.66289 5.6629 5.6629c.3905.3905.3905 1.0237 0 1.4142s-1.0237.3905-1.4142 0l-5.6629-5.6629-5.66289 5.6629c-.39052.3905-1.02369.3905-1.41421 0-.39053-.3905-.39053-1.0237 0-1.4142l5.6629-5.6629-5.6629-5.66289c-.39053-.39052-.39053-1.02369 0-1.41421.39052-.39053 1.02369-.39053 1.41421 0l5.66289 5.6629z"
            fill="#2e4068"
            fill-rule="evenodd"
          />
          <g stroke="#2e4068" stroke-linecap="round" stroke-width="2">
            <path d="m4 4 16 16" />
            <path d="m20 4-16 16" />
          </g>
        </svg>
      </span>
    </div>
    <div class="all-status">
      <div
        class="status-block"
        [class.open]="sideBarItemsOpened | idIncludes : item.id"
        *ngFor="let item of items"
      >
        <div
          class="block-top cursor-pointer"
          (click)="triggerToggleSideBarOpen(item.id)"
        >
          <i class="icon-track_number"></i
          ><span class="all-st" [ngStyle]="sidebar | fontFamily">{{
            item.display || 'None'
          }}</span>
          <span class="float-right">
            <span class="amount-tn ml-auto" [ngStyle]="sidebar | fontFamily">
              {{ item?.itemsCount }}
            </span>
            <span class="sidebar-arrow" *ngIf="items.length > 1">
              <i class="icon-arrow-point-to-right fs-18"></i>
            </span>
          </span>
        </div>
        <!-- /block-top -->
        <ng-container *ngFor="let tn of item.items">
          <div
            *ngIf="tn.number && tn.number !== item.display"
            class="status-block-line cursor-pointer"
            [class.active]="selectedItem === tn.id"
            (click)="triggerSelectTrackingNumber(tn.id)"
          >
            <span class="w-50 truncate-350">
              <i class="icon-parcel"></i>
              <span class="all-st" [ngStyle]="sidebar | fontFamily">
                {{ tn.number }}
              </span>
            </span>
          </div>
          <div
            class="status-block-line cursor-pointer"
            [class.active]="selectedItem === block.id"
            *ngFor="let block of tn.trackingNumbers"
            (click)="triggerSelectTrackingNumber(block.id)"
          >
            <span class="w-50 truncate-350">
              <i class="icon-parcel"></i>
              <span class="all-st" [ngStyle]="sidebar | fontFamily">
                {{ block.display || 'None' }}
              </span>
            </span>

            <span
              class="right-block-line w-50 truncate-350"
              [ngStyle]="sidebar | fontFamily"
            >
              <app-tracking-page-status
                [status]="block.status"
              ></app-tracking-page-status>
            </span>
          </div>
        </ng-container>
      </div>
      <!-- /status-block open -->
    </div>
    <div
      class="show-more"
      *ngIf="loadMoreVisible"
      (click)="showMore.emit()"
      [ngStyle]="sidebar | fontFamily"
    >
      {{ 'sidebar_show_more' | translate }} (<strong>{{ moreValues }}</strong
      >)
    </div>
  </div>
</div>
<!-- /wrapper-status -->
